
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Chart from "chart.js";

@Component({})
export default class Diagramme extends Vue {

  @Prop()
  public data: number[];
  public myChart: Chart;
  @Prop()
  public type: string;
  @Prop()
  public labels: string[];
  @Prop()
  public backgroundColor: any;
  @Prop()
  public titleChart: string;
  @Prop()
  public id: string;

  @Watch("data", { deep: true })
  public handleChart() {
    this.myChart.data.datasets[0].data = this.data;
    this.myChart.update();
  }

  public createBarChart(data) {
    const barChart = document.getElementById(this.id) as HTMLCanvasElement;
    this.myChart = new Chart(barChart, {
      type: this.type,
      data: {
        labels: this.labels,
        datasets: [{
          label: "",
          data,
          backgroundColor: this.backgroundColor,
        }],
      },
      options: {
        title: {
          display: true,
          text: this.titleChart,
        },
        legend: {
          display: false,
        },
        scales: {
          yAxes: [{
            type: "logarithmic",
          }],
        },
      },
    });
  }

  private mounted() {
    this.createBarChart(this.data);
  }
}
